import { CodeNameModel } from 'components/common/types';
import {
  ProductIdentifier,
  ProductTemplateResponse,
  GroupedByFolderProductTemplates,
} from 'components/common/types/DirectSalesProductTemplate.types';

export const groupedByFolder = (products: ProductIdentifier[]): GroupedByFolderProductTemplates => {
  return products.reduce<Record<string, CodeNameModel[]>>((acc, product) => {
    const { folder, id, name } = product;

    if (!acc[folder]) {
      acc[folder] = [];
    }

    acc[folder].push({
      code: id,
      name,
    });

    return acc;
  }, {});
};

export const transformProductList = (products: ProductTemplateResponse[]): ProductIdentifier[] => {
  return products.map(({ id, name, folder, status }) => ({
    id,
    name,
    folder: folder || 'Unknown',
    status,
  }));
};
